<template>
  <v-container class="d-flex align-center justify-center fill-height mt-8">
    <v-card class="pa-4" min-width="350px">
      <v-card-title>
        <v-img src="@/assets/logo.png" alt="E-Photo Logo" max-height="60"></v-img>
      </v-card-title>
      <v-card-text>
        <v-form @submit.prevent="login" class="mt-6">
          <v-text-field v-model="username" label="Username" required></v-text-field>
          <v-text-field v-model="password" label="Password" type="password" required></v-text-field>
          <v-btn type="submit" color="primary" class="mb-4">Login</v-btn>
          <v-btn color="secondary" class="ml-2 mb-4" @click="goToRegister">Register</v-btn>
        </v-form>
        <v-alert v-if="computedError" type="error">{{ computedError  }}</v-alert>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'LoginBlog',
  data() {
    return {
      username: '',
      password: '',
      error: null,
    };
  },
  mounted() {
    localStorage.setItem('token', '');
    localStorage.setItem('user', '');
    localStorage.setItem('isAdmin', '0');
    localStorage.setItem('isProducer', false);
  },
  computed: {
    computedError() {
      return this.error;
    }
  },
  methods: {
    async login() {
      try {
        const response = await axios.post(process.env.VUE_APP_SERVER3 + '/login', {
          username: this.username.toLowerCase(),
          password: this.password,
        });
        console.log(response)
        
        console.log('isProducer: ',response.data.prod)
        if(response.data.prod == 1){
          localStorage.setItem('isProducer', true);
          this.$store.commit('setProducerStatus', true);          
        }else{
          localStorage.setItem('isProducer', false);
          this.$store.commit('setProducerStatus', false);
        }
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', this.username.toLowerCase());
        if(process.env.VUE_APP_EMAIL_ADMIN.includes(this.username.toLowerCase())){
          localStorage.setItem('isAdmin', '1');
          this.$store.commit('setAdminStatus', true);          
        }
        else
          this.$store.commit('setAdminStatus', false);
        
        this.$router.push('/board');
      } catch (error) {
        this.error = 'Login failed';
        console.error('Error:',error);
      }
    },
    goToRegister() {
      this.$router.push('/register');
    }
  },
};
</script>

<style scoped>
.fill-height {
  height: 100vh;
}
</style>
